import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material"

const DeletePurchaseOrderDialog = ({
  open,
  onClose,
  onConfirm,
  hasLinkedExpense,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{i18n.t("purchaseOrders.deletePurchaseOrder")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {i18n.t("purchaseOrders.deletePurchaseOrderConfirmation")}
        </DialogContentText>
        {hasLinkedExpense ? (
          <DialogContentText sx={{ mt: 2 }}>
            {i18n.t("purchaseOrders.deleteLinkedExpenseWarning")}
          </DialogContentText>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="secondary">
          {i18n.t("invoices.cancel")}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {i18n.t("buttons.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeletePurchaseOrderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  hasLinkedExpense: PropTypes.bool,
}

DeletePurchaseOrderDialog.defaultProps = {
  hasLinkedExpense: false,
}

export default DeletePurchaseOrderDialog
